import {isCopilot} from '@github-ui/assignees/copilot-user'
import type {Reviewer} from '@github-ui/dotcom-schema/types/pull_requests/v1/reviewer'

const COPILOT_REVIEWER_SLUG = 'copilot-pull-request-reviewer'

export function isCopilotPullRequestReviewer(reviewer: Pick<Reviewer, 'slug'> | undefined): boolean {
  return normalizeReviewerSlug(reviewer?.slug) === COPILOT_REVIEWER_SLUG
}

export function isCopilotReviewer(reviewer: Pick<Reviewer, 'displayLogin' | 'slug'> | undefined): boolean {
  return isCopilotPullRequestReviewer(reviewer) || isCopilot(reviewer?.displayLogin ?? '')
}

export function normalizeReviewerSlug(slug: string | null | undefined): string {
  return (slug ?? '').replace(/\[bot\]$/, '')
}
